export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/advantages.6165f56e-96fae4.png";